<template>
  <div v-loading="loading">
    <ul class="aside_box appPrivacy">
      <li v-if="aside!=2" class="titleLi" @click="Aside('2')">{{ $t('title.userAgreement') }}</li>
      <li v-if="aside==2">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=1" class="titleLi" @click="Aside('1')">privacyNotice{{ $t('title.privacyNotice') }}</li>
      <li v-if="aside==1">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=3" class="titleLi" @click="Aside('3')">{{$t('title.chTradingRules')}}</li>
      <li v-if="aside==3">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=4" class="titleLi" @click="Aside('4')">{{$t('title.auctionRules')}}</li>
      <li v-if="aside==4">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=7" class="titleLi" @click="Aside('7')">{{$t('title.closingDeleting')}}</li>
      <li v-if="aside==7">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=8" class="titleLi" @click="Aside('8')">{{ $t('title.boxesCases') }}</li>
      <li v-if="aside==8">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=15" class="titleLi" @click="Aside('8')">{{ $t('title.antiFraud') }}</li>
      <li v-if="aside==15">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=9" class="titleLi" @click="Aside('8')">{{ $t('title.antiMoney') }}</li>
      <li v-if="aside==9">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
//从app.vue 往 Child.vue中传递信息。
import bus from '@/api/bus';
export default {
  name: 'index',
  data() {
    return {
      loading: false,
      list: '',
      aside: 2,
      //policies: this.$enumInfo.policies,
      title: this.$t('title.rulesAPolicies')
    }
  },
  mounted() {},
  created() {
    this.aside = this.$route.query.type ? this.$route.query.type : '2';
    this.Aside(this.aside)
    // document.title = this.policies[this.aside];
    // this.GetAgreements()
  },
  methods: {
    SetRulesTitle(val){
      var name=''
      switch (val){
      case '1':
        name=this.$t('title.privacyNotice')
        break
      case '2':
        name=this.$t('title.userAgreement')
        break
      case '3':
        name=this.$t('title.chTradingRules')
        break
      case '4':
        name=this.$t('title.auctionRules')
        break
      case '5':
        name=this.$t('title.activityRule')
        break
      case '6':
        name=this.$t('title.settlementAgreement')
        break
      case '7':
        name=this.$t('title.closingDeleting')
        break
      case '8':
        name=this.$t('title.boxesCases')
        break
      case '9':
        name=this.$t('title.antiMoney')
        break
      case '15':
        name=this.$t('title.antiFraud')
        break
      }
      document.title=name
    },
    Aside(val) {
      this.aside = val;
      this.SetRulesTitle(val)
      this.GetAgreements();
      window.scrollTo(0, 0)
    },
    GetAgreements() {
      let that = this
      let data = { ServiceAgreementType: this.aside }
      that.loading = true;
      this.$get(this.$interface.GetNewServiceAgreements, data).then(res => {
        if (res.Result != 0) {
          if (res.Data.length > 0) {
            this.list = res.Data[0]
          } else {
            this.list.Content = ""
          }
        }
        that.loading = false;
      })
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/terms.css";

</style>



// WEBPACK FOOTER //
// src/pages/terms/appprivacy.vue